import { userInfoSelector } from "@/recoil/userInfo";
import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useEffect } from "react";
import { deviceTypeState } from "@/recoil/deviceType";
import { readProfileId } from "@/lib/authFunctions";
import { navigatorRoutePushScreen } from "@/lib/flutterFuntions";

export const PrivateRoute = () => {
  const userInfo = useRecoilValue(userInfoSelector);
  const deviceType = useRecoilValue(deviceTypeState);
  // const selectProfileId = useRecoilValue(profileIdState);
  const selectProfileId = readProfileId();

  useEffect(() => {
    if (deviceType === "pad" && selectProfileId && userInfo) {
      navigatorRoutePushScreen("/content-dashboard");
    }
  }, []);

  if (!userInfo) {
    return <Navigate to="/intro" replace />;
  }

  if (deviceType === "pad" && selectProfileId && userInfo) {
    // return null;
    return <Navigate to="/home" />;
  }

  if (deviceType === "phone" && userInfo) {
    return <Navigate to="/home" />;
  }

  if (userInfo?.is_first_login) {
    return <Navigate to="/auth/join/select" replace />;
  }

  return <Navigate to="/auth/profile/select" replace />;
};
